'use client';

import { useEffect } from 'react';

import { getLenisInstance } from '@/lib/scroll';

/**
 * Prevents background scroll while `active`, compensating for the scrollbar width
 * to avoid layout shift. Also stops Lenis so nested overflow regions (e.g. overlay
 * panels) can receive wheel / touch scroll.
 */
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;

    const { overflow, paddingRight } = document.body.style;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    const lenis = getLenisInstance();
    lenis?.stop();

    return () => {
      document.body.style.overflow = overflow;
      document.body.style.paddingRight = paddingRight;
      lenis?.start();
    };
  }, [active]);
}
